module.exports = __webpack_public_path__ + "img/recruiterMessage.d65cf666.svg";